<template>
	<div class="search-input-wrapper">
		<md-field class="input-group search-input-group">

			<md-input type="text"
					  id="search-input"
					  name="searchtext"
					  class="form-control search-input"
					  aria-label="Search Products, Suppliers..."
					  autocomplete="off"
					  v-model.lazy="query"
					  @keyup.enter="hit"
					  @keydown.down="down"
					  @keydown.up="up"
					  @keydown.enter="addApiUrls()"
					  @keydown.esc="reset"
					  @input="inputHandler">
			</md-input>

			<div class="search-typeahead" v-show="hasItems">	
				<ul>
					<li v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
						<span class="name" v-html="item.SupplierName"></span>
						
					</li>
				</ul>
			</div>
			<div v-if="items.length === 0 && query.length > 2" class="search-typeahead">
				<ul><li><span>No results found</span></li></ul>
			</div>

			<label for="search-input" class="form-control-placeholder">Search Products, Suppliers...</label>
			<span class="input-group-btn search-clear" v-if="query != '' && query != null">
				<input type="submit" value="" class="icon-close submit-input" v-on:click="clearSearch()" />
			</span>
			<span class="input-group-btn search-submit">
				<input class="icon-search submit-input" type="submit" value="search" v-on:click="addApiUrls()" />
			</span>
		</md-field>
	</div>
</template>

<script>
	import VueTypeahead from 'vue-typeahead';
	import * as Constants from 'constants';
	import { EventBus, EVENT_FILTER_CLEAR} from '../../common/event-bus';

	export default {
		extends: VueTypeahead,
		props: ['searchtext'],
		data: function () {
			return {
				src: Constants.ENVIRONMENT_API + 'products?page=1&itemsPerPage=5',
				query: '',
				minChars: 3,
				queryParamName: 'keywords'
			}
		},
		watch: {
			searchtext(val, oldVal) {
				this.query = val;
			}
		},
		mounted() {
			this.query = this.searchText || '';

			EventBus.$on(EVENT_FILTER_CLEAR, this.clearSearch);
		},
		methods: {
			addApiUrls() {
				this.$emit('addsearchtext', this.query);
			},
			clearSearch() {
				this.query = '';
				this.addApiUrls();
			},
			inputHandler() {
				this.update();
				this.$emit('updatesearchtext', this.query);
			},
			onHit(item) {
				window.location.href = 'products/detail/' + item.SupplierId
			},
			// The callback function which is triggered when the response data are received
			prepareResponseData(data) {
				return data.Data.Items;
			}
		},
	}
</script>